module.exports = __webpack_public_path__ + "img/smiley.a13a73e6.svg";